import COMPANY_API from '@/api/masterData/company.js';
import BASE_API from '@/api/dataBase';

export const signSpaceCells = () => {
  return [
    {
      title: '租赁空间',
      field: 'leaseSpace',
      width: '300',
    },
    {
      title: '租赁面积',
      field: 'leaseSpaceArea',
      width: '300',
    },
    {
      title: '租赁期限',
      field: 'leaseDate',
      width: '400',
    },
  ];
};

export const signInfoCells = () => {
  return [
    {
      name: '入驻联系人',
      prop: 'merchantContactPerson',
      type: 'input',
      disabled: true,
    },
    {
      name: '联系电话',
      prop: 'merchantContactPhone',
      type: 'input',
      disabled: true,
    },
    {
      name: '合同编号',
      prop: 'relatedContractNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '合同状态',
      prop: 'relatedContractStatus',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROPERTY-CONTRACT-STATUS' },
      disabled: true,
    },
    {
      name: '租金',
      prop: 'leaseRentAmount',
      type: 'input',
      disabled: true,
    },
  ];
};

export const formCells = (ctx) => {
  return [
    {
      prop: 'nicheCompanyNo',
      name: '公司',
      type: 'select',
      placeholder: '请选择公司',
      value: 'personCompanyCode',
      label: 'personCompanyName',
      options: JSON.parse(ctx.userInfo.companyList),
      currentValue: ctx.baseInfoData.nicheCompanyName,
      clearable: true,
      filterable: true,
      changeMethod: 'changeCompanyHandler',
    },
    {
      prop: 'nicheDepartmentCode',
      name: '部门',
      type: 'ajaxSelect',
      apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
      apiData: {
        belongCompanyCode: ctx.baseInfoData.nicheCompanyNo,
        tenantCode: ctx.userInfo.tenantCode,
      },
      clearable: true,
      filterable: true,
      disabled: !ctx.baseInfoData.nicheCompanyNo,
      currentValue: ctx.baseInfoData.nicheDepartmentName,
      valueKey: 'createDepartmentCode',
      labelKey: 'createDepartmentName',
      changeMethod: 'changeDepartmentHandler',
      valueType: 'object',
      method: 'post',
    },
    {
      prop: 'customerCode',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'customer',
      currentValue: ctx.baseInfoData.customerName,
      isMultiple: true,
      changeMethod: 'changeValueHandler',
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
      },
    },
    {
      prop: 'intentionAmount',
      type: 'inputNumber',
      name: '意向金',
      precision: 2,
    },
    {
      name: '联系人',
      prop: 'contactPerson',
      type: 'input',
      maxlength: 10,
    },
    {
      name: '联系电话',
      prop: 'contactPhone',
      type: 'inputNumber',
      precision: 0,
      maxlength: 20,
    },
  ];
};

export const detailFormCells = (ctx) => {
  return [
    {
      name: '招商编号',
      prop: 'nicheNo',
      type: 'input',
      span: 8,
    },
    {
      prop: 'nicheCompanyNo',
      name: '公司',
      type: 'select',
      placeholder: '请选择公司',
      value: 'personCompanyCode',
      label: 'personCompanyName',
      options: JSON.parse(ctx.userInfo.companyList),
      currentValue: ctx.baseInfoData.nicheCompanyName,
      clearable: true,
      filterable: true,
      changeMethod: 'changeCompanyHandler',
      span: 8,
    },
    {
      prop: 'nicheDepartmentCode',
      name: '部门',
      type: 'ajaxSelect',
      apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
      apiData: {
        belongCompanyCode: ctx.baseInfoData.nicheCompanyNo,
        tenantCode: ctx.userInfo.tenantCode,
      },
      clearable: true,
      filterable: true,
      disabled: !ctx.baseInfoData.nicheCompanyNo,
      currentValue: ctx.baseInfoData.nicheDepartmentName,
      valueKey: 'createDepartmentCode',
      labelKey: 'createDepartmentName',
      changeMethod: 'changeDepartmentHandler',
      valueType: 'object',
      method: 'post',
      span: 8,
    },
    {
      prop: 'customerCode',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'customer',
      currentValue: ctx.baseInfoData.customerName,
      isMultiple: true,
      changeMethod: 'changeValueHandler',
      extraData: {
        // partnerTypes: 'HZHB03,HZHB01',
      },
      span: 8,
    },
    {
      prop: 'intentionAmount',
      type: 'inputNumber',
      name: '意向金',
      precision: 2,
      span: 8,
    },
    {
      name: '招商状态',
      prop: 'nicheStatus',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROPERTY-MERCHANT-STATUS' },
      span: 8,
    },
    {
      name: '入驻状态',
      prop: 'entryStatus',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROPERTY-MERCHANTS-ENTRY-STATUS' },
      span: 8,
    },
    {
      prop: 'entryDate',
      name: '入驻日期',
      type: 'date',
      span: 8,
    },
    {
      name: '联系人',
      prop: 'contactPerson',
      type: 'input',
      maxlength: 10,
      span: 8,
    },
    {
      name: '联系电话',
      prop: 'contactPhone',
      type: 'inputNumber',
      precision: 0,
      maxlength: 20,
      span: 8,
    },
    {
      name: '创建人',
      prop: 'createPersonName',
      type: 'input',
      span: 8,
    },
    {
      prop: 'gmtCreate',
      name: '创建时间',
      type: 'date',
      span: 8,
    },
  ];
};
